import {
  notifyManager,
  type QueryClient,
  type QueryFilters,
} from '@tanstack/react-query';

/**
 * Fences old reads without reverting accepted data or presenting cancellation as an error.
 * Query 5.15 leaves silent cancellations fetching; reset only interrupted queries so
 * an initial or inactive read can restart through its ordinary query function.
 * @param client - Account-owned query cache.
 * @param filters - Reads superseded by a mutation or recovery request.
 */
export const cancelQueryReads = (
  client: QueryClient,
  filters: QueryFilters
): void => {
  notifyManager.batch(() => {
    const interrupted = client
      .getQueryCache()
      .findAll(filters)
      .filter((query) => query.state.fetchStatus !== 'idle');
    void client.cancelQueries(filters, { revert: false, silent: true });
    interrupted.forEach((query) => query.setState({ fetchStatus: 'idle' }));
  });
};
